// src/pages/Dashboard.js — 餐廳營運台 首頁 (功能啟動頁)
//
// 首頁 = 功能卡片啟動頁:顯示登入公司 + 點卡片直接進對應管理頁。
//   線上訂位              → /restaurant/reservations (餐廳訂位)
//   AI 接聽電話/通話紀錄  → /call-logs (通話紀錄)
// 卡片依方案 (hasFeature) 標示已開通/未開通,但一律可點進頁面。
// 排隊候位 (P5) 尚未上線,先不顯示。
import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Grid,
  Typography,
} from '@mui/material';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import RecentReservationsCard from '../components/dashboard/RecentReservationsCard';
import { hasFeature } from '../utils/features';

const PILLARS = [
  {
    key: 'reservation',
    label: '線上訂位',
    desc: '顧客自助訂位、餐廳後台管理桌位與時段。',
    icon: <EventSeatIcon sx={{ fontSize: 36 }} color="primary" />,
    feature: 'reservationEnabled',
    path: '/restaurant/reservations',
  },
  {
    key: 'voice',
    label: 'AI 接聽電話/通話紀錄',
    desc: 'AI 接聽訂位電話、查看通話紀錄。',
    icon: <PhoneInTalkIcon sx={{ fontSize: 36 }} color="primary" />,
    feature: 'voiceEnabled',
    path: '/call-logs',
  },
];

const Dashboard = () => {
  const navigate = useNavigate();
  let user = {};
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    user = {};
  }
  const companyName = user?.companyName || user?.company?.name || '您的餐廳';
  const greetName = user?.name || user?.email || '';

  return (
    <Layout>
      {/* 手機：內容距螢幕邊 16px（iOS HIG 的 readable content margin）。
          Layout 的 <main> 是全站共用的 p:3(24px)，不能為了這頁改，
          所以這裡用 mx:-1(-8px) 把它扣回 16px —— 與訂單管理用 m:-3 走版
          是同一個作法。桌機維持原本的 p:4。 */}
      <Box sx={{ px: { xs: 0, md: 4 }, py: { xs: 2, md: 4 }, mx: { xs: -1, md: 0 } }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          歡迎回來{greetName ? `,${greetName}` : ''}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {companyName} · 餐廳營運台
        </Typography>

        <Grid container spacing={3}>
          {PILLARS.map((p) => {
            const enabled = hasFeature(p.feature);
            return (
              <Grid item xs={12} sm={6} md={4} key={p.key}>
                <Card
                  variant="outlined"
                  sx={{
                    height: '100%',
                    opacity: enabled ? 1 : 0.6,
                    borderColor: enabled ? 'primary.light' : 'divider',
                  }}
                >
                  <CardActionArea onClick={() => navigate(p.path)} sx={{ height: '100%' }}>
                    <CardContent>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          mb: 1,
                        }}
                      >
                        {p.icon}
                        <Chip
                          size="small"
                          label={enabled ? '已開通' : '未開通'}
                          color={enabled ? 'success' : 'default'}
                          variant={enabled ? 'filled' : 'outlined'}
                        />
                      </Box>
                      <Typography variant="h6" sx={{ mt: 1 }}>
                        {p.label}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        {p.desc}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })}
        </Grid>

        {/* 119 新進訂單 —— 加在功能卡「下面」，功能卡不動。
            這裡刻意不放任何統計數字（今日訂位/來客數…），
            這一頁的重點就是讓業主一進來就看到最新進的訂位。 */}
        <RecentReservationsCard />
      </Box>
    </Layout>
  );
};

export default Dashboard;
